<template>
	<div class="minibar">
		<v-layout row wrap>
			<v-flex md10>
				<filter-list class="mb-3" v-bind:value="filterValue" v-bind:loading="loading" v-on:selected-filter="selectedFilter" />
			</v-flex>
			<v-flex md2 class="text-xs-right">
				<button-create :text="buttonText" :href="createHref"></button-create>
			</v-flex>
		</v-layout>
		<table-run
			v-bind:columns="columns"
			v-bind:rows="rows"
			v-bind:include-delete="false"
			v-bind:include-export-to-excel="false"
			v-bind:include-options="true"
			v-bind:include-switch="true"
			v-bind:include-settings="true"
			v-bind:include-delete-single="true"
			v-bind:selectable="false"
			v-bind:switch-value="'flagActive'"
			v-on:on-sortable-event="columnSortableEvent"
			v-on:on-search-event="searchByColumn"
			v-on:on-change-state="changeState"
			v-on:on-delete-event="deleteRow"
			v-on:go-to-edit-page="goToEdit"
			class="no-selectable-table"
		>
			<template slot="rows" scope="props">
				<td>{{ props.row.code }}</td>
				<td>{{ props.row.name }}</td>
				<td>{{ props.row.code_roomtype }}<span v-if="props.row.code_roomtype && props.row.room_number">-</span>{{ props.row.room_number }}</td>
				<td class="column-transfer text-xs-right">
					<router-link :to="{ name: `${toTransferName}-products`,
						params: { id: props.row.id, name: props.row.name } }">
						<v-icon>input</v-icon>
					</router-link>
				</td>
			</template>
		</table-run>
		<v-layout row wrap justify-end mt-3 v-show="totalPages">
			<v-pagination
				:length="totalPages"
				:total-visible="pagesVisible"
				v-model="page"
				v-on:input="changePage">
			</v-pagination>
		</v-layout>
	</div>
</template>

<script>
import TableRun from 'table-run';
import mixin from '@/shared/mixins';
import warehouseResource from '@/resource/warehouse';
import ButtonCreate from '@/components/shared/ButtonCreate';
import FilterList from '@/components/shared/FilterList';

function mounted() {
	this.resource = warehouseResource(this);
	if (this.$route.name === 'warehouses-list') {
		this.buttonText = 'Almacén';
		this.createHref.name = 'warehouses-new';
		this.toTransferName = 'warehouses';
	} else {
		this.buttonText = 'Minibar';
		this.createHref.name = 'minibar-new';
		this.toTransferName = 'minibar';
	}
	this.loadData();
}

async function changePage(value) {
	this.page = value;
	this.loadData();
}

async function changeState({ id }) {
	const modelRow = this.rows.filter(row => row.id === id)[0];
	await this.$http.patch(`${process.env.PRODUCTS_URL}/p/warehouses/${id}/flag-active`, { flagActive: modelRow.flagActive });
	this.loadData();
}

function columnSortableEvent({ id }) {
	const self = this;
	const newColumn = self.columns.filter(column => column.id === id);
	newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map((columnSingle) => {
		const newColumnSingle = Object.assign({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.sortField = newColumn[0].code;
	this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

async function deleteRow({ id }) {
	try {
		await this.$http.delete(`${process.env.PRODUCTS_URL}/p/warehouses/${id}`);
		this.loadData();
	} catch (err) {
		const error = err.data;
		if (error.message === 'WAR_HAS_PRODUCTS') {
			this.showNotification('El minibar no se puede eliminar porque ya tiene productos', 'warning');
		}
	}
}

function goToEdit({ id }) {
	const editHref = { name: `${this.toTransferName}-config`, params: { minibarId: id } };
	this.$router.push(editHref);
}

async function loadData() {
	const parameters = {
		page: this.page,
		limit: this.limit,
	};
	if (this.flagActive || this.flagActive === 0) {
		parameters.flagActive = this.flagActive;
	}
	if (this.search) {
		parameters.search = this.search;
	}
	if (this.sortField) {
		parameters.sortField = this.sortField;
	}
	if (this.sortDirection) {
		parameters.sortDirection = this.sortDirection;
	}
	const minibar = this.$route.name === 'minibar-list' ? 1 : 0;
	const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/warehouses?minibar=${minibar}`, { params: parameters });
	this.totalPages = Number(response.headers.get('x-last-page'));
	this.rows = response.data;
	this.loading = false;
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	this.search = search;
	this.page = 1;
	this.loadData();
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	if (filter.id === 2) {
		this.flagActive = 1;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else if (filter.id === 3) {
		this.flagActive = 0;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else {
		this.flagActive = null;
		this.loading = true;
		this.page = 1;
		this.loadData();
	}
}

export default {
	components: {
		ButtonCreate,
		FilterList,
		TableRun,
	},
	computed: {
		pagesVisible,
	},
	watch: {
		$route(newVal) {
			if (typeof newVal !== 'undefined') {
				this.loadData();
				if (newVal.name === 'warehouses-list') {
					this.buttonText = 'Almacén';
					this.createHref.name = 'warehouses-new';
					this.toTransferName = 'warehouses';
				} else {
					this.buttonText = 'Minibar';
					this.createHref.name = 'minibar-new';
					this.toTransferName = 'minibar';
				}
			}
		},
	},
	data() {
		return {
			buttonText: '',
			columns: [
				{ id: 1, name: 'Code', code: 'code', isSortable: { down: false, up: false } },
				{ id: 2, name: 'Name', code: 'name', isSortable: { down: false, up: false } },
				{ id: 3, name: 'Room', code: '' },
				{ id: 4, name: '', code: '' },
			],
			createHref: {},
			filterValue: 1,
			flagActive: null,
			limit: 10,
			loading: false,
			page: 1,
			resource: null,
			rows: [],
			search: null,
			sortDirection: null,
			sortField: null,
			totalPages: 5,
			toTransferName: '',
		};
	},
	name: 'minibar',
	methods: {
		changePage,
		changeState,
		columnSortableEvent,
		deleteRow,
		goToEdit,
		loadData,
		searchByColumn,
		selectedFilter,
	},
	mixins: mixin,
	mounted,
};
</script>

<style lang="scss" scoped>
	.column-transfer {
		position: absolute;
		right: 158px;

		a {
			i {
				color: map-get($colors, blue-title);
				height: 16px !important;
				margin-top: 13px;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// List.vue?30559c71